// Components
import { CancelButton, Card, CommandButton } from "components"
import { AttachmentModal } from "./AttachmentModal"
import { Journal } from "./Journal"
import { useFormContext, useWatch } from "react-hook-form"
import { FormReturnItemsType } from "../types"
import { APPROVAL } from "utils"
import { Print } from "./Print"

// Form
// import { useFormContext, useWatch } from "react-hook-form"
// import type { FormReturnItemsType } from "../types"

type CommandButtonsProps = {
  approvalView?: boolean
  showSaveButton?: boolean
  showDeleteButton?: boolean
  onDelete?: () => void
  onSave?: () => void
  isSaveDisabled?: boolean
}

export const CommandButtons = ({
  approvalView,
  showSaveButton,
  showDeleteButton,
  onDelete,
  onSave,
  isSaveDisabled = false,
}: CommandButtonsProps) => {
  // Form
  const { control } = useFormContext<FormReturnItemsType>()
  const approvalStatus = useWatch({
    control,
    name: "approval_status"
  })

  return (
    <>
      <Card className={approvalView ? "hidden" : ""}>
        <Card.Body className="flex flex-col gap-5">
          <section className="flex flex-wrap justify-between gap-3">
            <section className="flex flex-wrap gap-3">
              <Print/>
              <Journal />
             <AttachmentModal/>
            </section>

            <section className="flex flex-wrap gap-3">
              <CancelButton />

              {showDeleteButton && (
                <CommandButton actiontype="delete" onClick={onDelete} disabled={APPROVAL.APPROVED === approvalStatus} />
              )}

              {showSaveButton && (
                <CommandButton
                  actiontype="save"
                  type="button"
                  color="primary"
                  permission="ST121"
                  onClick={onSave}
                  disabled={isSaveDisabled || APPROVAL.APPROVED === approvalStatus}
                />
              )}
            </section>
          </section>
        </Card.Body>
      </Card>
    </>
  )
}
